import React, { Component } from "react";
import "./styles/Sms.css";
import withAuthorization from "./withAuthorization";
import Parser from "../functions/idParser";
import URL from "../constants/url";
import Snackbar from "@material-ui/core/Snackbar";
import SnackbarContent from "@material-ui/core/SnackbarContent";
import ErrorIcon from "@material-ui/icons/Error";
import InfoIcon from "@material-ui/icons/Info";
import CloseIcon from "@material-ui/icons/Close";
import IconButton from "@material-ui/core/IconButton";

import ExpansionPanel from "./ExpansionPanel";
import ExpansionPanel2 from "./ExpansionPanel2";
import AlertDialog2 from "./AlertDialog2";

import { Button, Divider } from "@material-ui/core";
// import Services from "./services";
import SnackAlert from "./SnackAlert";

import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import AuthUserContext from "./AuthUserContext";
import { firebase } from "../firebase";
import { auth, firestore } from "../firebase/firebase";

import CircularProgress from "@material-ui/core/CircularProgress";
import purple from "@material-ui/core/colors/purple";
const Spinner = require("react-spinkit");

const axios = require("axios");

// let numbersContainer = Object.entries(Services).map((i, index) => {
//   return (
//     // <div className="p-2" id={`number-${i[1].name}`} onClick={handleClick}>
//     <div className="p-2" id={`number-${i[1].name}`} onClick={handleClick}>
//       <img src={i[1].image} />
//       <span className="service-name">{i[1].name}</span>
//       {console.log(i[1])}
//       {/* <span class="badge badge-warning">$0.25</span> */}
//       <Button variant="contained" color="primary" size="small">
//         {"$" + i[1].price}
//       </Button>
//       {/* <span class="badge badge-primary">{"15"} pcs.</span> */}
//       <Divider inset style={{ marginLeft: "40px" }} />
//     </div>
//   );
// });
let Services;

class Abc extends React.Component {
  render() {
    return (
      <div>
        <button onClick={this.props.handler}>CLICKKK</button>
      </div>
    );
  }
}

// const ServicesContainer = () => {
//   return(

//   )
// }

function handleClick(e) {
  // console.log("Clicked item->", e.currentTarget.id);
}

let numbers = [];

let numbersPrint;

function sortObjectsArray(objectsArray, sortKey) {
  // Quick Sort:
  var retVal;

  if (1 < objectsArray.length) {
    var pivotIndex = Math.floor((objectsArray.length - 1) / 2); // middle index
    var pivotItem = objectsArray[pivotIndex]; // value in the middle index
    var less = [],
      more = [];

    objectsArray.splice(pivotIndex, 1); // remove the item in the pivot position
    objectsArray.forEach(function(value, index, array) {
      value[sortKey] <= pivotItem[sortKey] // compare the 'sortKey' proiperty
        ? less.push(value)
        : more.push(value);
    });

    retVal = sortObjectsArray(less, sortKey).concat(
      [pivotItem],
      sortObjectsArray(more, sortKey)
    );
  } else {
    retVal = objectsArray;
  }

  return retVal;
}

class Numbers extends React.Component {
  componentWillMount() {
    axios.get(`${URL}/services`).then(services => {
      let sortedServices = sortObjectsArray(services.data, "name");
      console.log(services);

      let ANY;

      numbersPrint = Object.entries(sortedServices).map((i, index) => {
        return (
          // <div className="p-2" id={`number-${i[1].name}`} onClick={handleClick}>
          <div
            className="p-2"
            id={`number-${i[1].name}`}
            onClick={this.handler}
            key={index}
          >
            {console.log(i[1])}
            <img src={i[1].image} />
            <span className="service-name">{i[1].name}</span>
            {/* {console.log(i[1])} */}
            {/* <span class="badge badge-warning">$0.25</span> */}
            <Button variant="contained" color="primary" size="small">
              {"$" + i[1].price / 100}
            </Button>
            {/* <span class="badge badge-primary">{"15"} pcs.</span> */}
            <Divider inset style={{ marginLeft: "40px" }} />
          </div>
        );
      });
      this.setState({ servicesLoading: false });
    });

    // willmunt end
  }

  constructor(props) {
    super(props);
    let uri;
    // this.uri = this.uri.bind(this);

    this.handler = this.handler.bind(this);

    this.state = {
      servicesLoading: true,
      open: false,
      numbers,
      selected: "",
      selectedNumber: "",
      parsedCode: "",
      fullText: "",
      renderPanel2: false,
      snackOpen: false,
      snackWarning: false,
      balance: "",
      selectedCountry: "USA",
      UKNumberId: ""
    };

    // console.log(numbers);
  }

  destroy = () => {
    this.setState({
      open: false,
      selected: "",
      selectedNumber: "",
      parsedCode: "",
      fullText: "",
      renderPanel2: false,
      snackOpen: false,
      snackWarning: false
    });
  };

  // servıse tıklandıgında calısan fonksıyon
  handler(e) {
    e.preventDefault();
    // console.log(this.state.alert2);
    if (!!this.state.selected) {
      {
        alert("You have to cancel your current in order to buy a new one.");
      }
    } else {
      this.setState({
        selected: Parser(e.currentTarget.id),
        open: true
      });
    }
  }

  handleClickOpen = () => {
    this.setState({ open: true });
  };

  handleClose = () => {
    // this.setState({ open: false });
    this.setState({ open: false, selected: "" });
  };

  handleBuy = e => {
    e.preventDefault();

    if (!this.state.selectedNumber) {
      this.setLoaderState(true);

      {
        /* TODO: database de halhazirda aktif bir order var mi diye kontrol et
          in case of page refresh */
      }

      // TODOEND:
      this.setState({
        open: false
      });
      // console.log("buy clicked");
      if (this.state.selectedCountry == "USA") {
        this.uri = `${URL}/getnumber/test/` + this.state.selected;
        // console.log(this.uri);
        axios
          .post(this.uri, { user: auth.currentUser.uid })
          .then(response => {
            // console.log(response);
            if (response.data.status === "insufficient") {
              // this.setLoaderState(false);
              this.setState({
                loading: false,
                selected: ""
              });
              alert("Insufficient Balance!");
            } else {
              this.setState({
                selectedNumber: response.data.number,
                // open: false,
                renderPanel2: true,
                expiry: response.data.expiry,
                loading: false
              });
              // console.log(this.state);
              // this.setLoaderState(false);
            }
          })
          .catch(err => {
            // console.log("errror");
            this.setState({
              snackOpen: true
            });
            this.handleClose();
            this.setLoaderState(false);
            // console.log(err);
          });
      } else {
        // TODO: UK number icin al islemleri

        axios.post(`${URL}/uk/getnumber/`);
      }
    } else {
      // console.log("Nothing to do");
    }

    // this.setState({ open: false });
    // this.setState({ open: false, selected: "" });
  };

  handleSkip = event => {
    event.preventDefault();
    this.setLoaderState(true);
    console.log(this.state);
    if (this.state.fullText == "") {
      axios
        .post(`${URL}/cancel/skip`, {
          uid: auth.currentUser.uid,
          service: this.state.selected,
          selectedNumber: this.state.selectedNumber
        })
        .then(response => {
          // console.log(response);
          if (response.data.status === "No number left") {
            // this.setLoaderState(false);
            this.setState({
              loading: false,
              selected: ""
            });
            alert("No number for this service! Please try again later.");
          } else {
            this.setState({
              selectedNumber: response.data.number,
              // open: false,
              renderPanel2: true,
              expiry: response.data.expiry,
              loading: false
            });
            // console.log(this.state);
            // this.setLoaderState(false);
          }
        })
        .catch(err => {
          // console.log("errror");
          this.setState({
            snackOpen: true
          });
          this.handleClose();
          this.setLoaderState(false);
          // console.log(err);
        });
    } else {
      alert(
        "You can't skip the number because you already received verification code."
      );
    }
    this.setLoaderState(false);
  };

  checkUK = () => {
    // TODO: axiosa psot gonder UK number a sms gelmis mi baksin
    let id = this.state.UKNumberId;
    let service = this.state.selected;

    console.log("numbers ocmpnent check uK");
  };

  closeSnackbar = () => {
    this.setState({
      snackOpen: false
    });
  };

  openSnackbar = () => {
    this.setState({
      snackOpen: true
    });

    const config = {
      snack: {
        backgroundColor: "#fff",
        color: "#444"
      }
    };
  };

  // TODO: FIXME: text mesaji geldiginde updateHeaderBalance fonksiyonunu calistir
  updateHeaderBalance = () => {
    let query = {};
    query["user"] = auth.currentUser.uid;
    // console.log(query);
    axios.post(URL + "/balance", query).then(response => {
      // console.log(response.data.balance);
      // this.setState({ balance: response.data.balance / 100 });
      document.getElementById("balanceSpan").innerHTML = `Balance: $${response
        .data.balance / 100}`;
    });
    // document.getElementById("balanceSpan").innerHTML = `Balance: ${
    //   this.state.balance
    // }`;
  };

  componentDidMount() {
    // console.log(this.props);
    this.updateHeaderBalance();

    axios
      .post(URL + "/check", { user: auth.currentUser.uid })
      .then(response => {
        // console.log(response);
        if (response.status === 200) {
          // Eger aktif bir order var ise
          console.log("aktif bir order var,o display ediliyor...");
          firestore
            .collection("active")
            .doc(response.data.latestNumber)
            .get()
            .then(documentSnapshot => {
              if (documentSnapshot.exists) {
                // do something with the data
                // if (documentSnapshot.data()[response.data.latestService]) {
                //   console.log(
                //     documentSnapshot.data()[response.data.latestService]
                //   );
                // } else {
                //   console.log("doc exists", documentSnapshot.data());
                // }
                /*TODO: 
                eger snaptshot.data(). service exist...
                TODOEND:*/

                // console.log(documentSnapshot.data());
                this.setState({
                  selectedNumber: response.data.latestNumber,
                  selected: response.data.latestService,
                  open: false,
                  renderPanel2: true,
                  expiry: response.data.expiry
                });
                // console.log("STATE", this.state);
              } else {
                // console.log("document not found");
              }
            });
        } else {
          // aktif bir order yok ise bir bok yapma
        }

        // console.log(this.state);
      })
      .catch(err => {
        // console.log("errror");
      });
  }

  setLoaderState = option => {
    // console.log(option);
    this.setState({
      loading: option
    });
  };

  render() {
    return (
      <div className="container">
        {/* {console.log(this.state)} */}
        <div>
          <div
            className="overlay"
            // color="rgba(0,123,255,.5)"
            style={{
              display: this.state.loading ? "flex" : "none ",
              color: "rgba(0,123,255,.5) !important"
            }}
          >
            {/* <Spinner className="spinner" name="line-scale" color="#9820e0" /> */}
            <CircularProgress
              className={"classes.progress"}
              style={{ color: purple[500] }}
              thickness={4}
              size={70}
            />
          </div>
        </div>
        {/* {console.log(auth)} */}
        <div className="row">
          <div className="col col-12 col-md-4" id="number-select">
            <div className="card countrySelector">
              <div className="card-header" id="balanceHeader">
                Select Service
              </div>
              <div className="card-body">
                {/* <div> {this.state.numbers}</div> */}
                <div>
                  {" "}
                  {this.state.servicesLoading ? "Loading..." : numbersPrint}
                </div>
              </div>
            </div>
          </div>
          <div className="col col-12 col-md-6" id="asdsa">
            {/* {cc} */}
            {/* <Abc handler={this.handler} /> */}
            {/* {this.state.selected} */}
            <ExpansionPanel
              parentState={this.state}
              parentDestroy={this.destroy}
              parentSkip={this.handleSkip}
              user={auth.currentUser.uid}
              setLoaderState={this.setLoaderState}
              checkUK={this.checkUK}
            />
            {/*
             // 2. paneli sadece numara geldigi zaman render et 
            cunku firebase ismi bos document okumayi kabul etmiyor
            */}
            {this.state.renderPanel2 == true ? (
              <ExpansionPanel2 parentState={this.state} />
            ) : null}
          </div>
        </div>
        {/* {console.log(firebase.auth.currentUser)} */}

        <Snackbar
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "left"
          }}
          open={this.state.snackOpen}
          autoHideDuration={6000}
          onClose={this.closeSnackbar}
        >
          <SnackbarContent
            // className={classNames(classes[variant], className)}
            aria-describedby="client-snackbar"
            message={
              <span id="client-snackbar" className={"classes.message"}>
                {/* <Icon
                  // className={classNames("classes.icon, classes.iconVariant")}
                /> */}
                {"No number left for selected service! Please try again later."}
              </span>
            }
            action={[
              <IconButton
                key="close"
                aria-label="Close"
                color="inherit"
                // className={classes.close}
                onClick={this.closeSnackbar}
              >
                <CloseIcon className={"classes.icon"} />
              </IconButton>
            ]}
          />
        </Snackbar>
        {/* <AlertDialog2 open={this.state.alert2} /> */}
        {/* {this.state.snackWarning ? (
          <SnackAlert open={true} />
        ) : (
          <SnackAlert open={false} />
        )} */}
        <SnackAlert open={this.state.snackWarning} />

        {/*  TODO:  servsie tiklandiginda UK ve US olarak iki secenek koy*/}
        <Dialog
          open={this.state.open}
          onClose={this.handleClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
          style={{ opacity: 0.95 }}
        >
          <DialogTitle id="alert-dialog-title">
            {`Buy `}
            <span style={{ color: "#29b3b3" }}>{this.state.selected}</span>
            {` Verification Number?`}
          </DialogTitle>
          <DialogContent>
            <p>Select your number's country</p>
            <div
              style={{
                display: "flex",
                justifyContent: "space-around",
                textAlign: "center"
              }}
            >
              <div
                id="usa-select"
                style={{ cursor: "pointer" }}
                onClick={() => {
                  this.setState({ selectedCountry: "USA" });
                }}
                className={
                  this.state.selectedCountry == "USA"
                    ? "selected-country"
                    : "nonselected-country"
                }
              >
                <img
                  src={require("./LandingPage/img/USA.svg")}
                  style={{ height: "65px" }}
                />
                <p>USA Number (+1)</p>
              </div>
              <div
                id="uk-select"
                style={{ cursor: "pointer" }}
                onClick={() => {
                  this.setState({ selectedCountry: "UK" });
                }}
                className={
                  this.state.selectedCountry == "UK"
                    ? "selected-country"
                    : "nonselected-country"
                }
              >
                <img
                  src={require("./LandingPage/img/UK.svg")}
                  style={{ height: "65px" }}
                />
                <p>UK Number (+44)</p>
              </div>
            </div>
            <DialogContentText id="alert-dialog-description">
              {`When you click BUY, you will receive a unique number to receive confirmation sms for ${
                this.state.selected
              }, but it only credited right after you successfully received sms `}
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={this.handleClose} color="primary">
              Cancel
            </Button>
            <Button onClick={this.handleBuy} color="primary" autoFocus>
              BUY
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  }
}

// export default Numbers;

// checks if the authUser object is not null
const authCondition = authUser => !!authUser;

// export default withAuthorization(authCondition)(HomePage);
export default withAuthorization(authCondition)(Numbers);
